import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useIsAffiliate = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["is-affiliate", user?.id],
    queryFn: async () => {
      if (!user) return false;
      
      const { data, error } = await supabase
        .from("affiliate_profiles")
        .select("id")
        .eq("user_id", user.id)
        .maybeSingle();
      
      if (error) {
        console.error("Error checking affiliate status:", error);
        return false;
      }
      
      return !!data;
    },
    enabled: !!user,
  });
};
